import { SharedState } from '$utils/sharedState.svelte';
import type { CirclesBackingDataEnvio } from '$types/envioTypes';

class StateCrcBacking extends SharedState<CirclesBackingDataEnvio> {}

export const stateCrcBacking = new StateCrcBacking(null);
